import JcPreview from './index.vue'

JcPreview.install = Vue => {
  Vue.component(JcPreview.name, JcPreview)
}

export default JcPreview



// WEBPACK FOOTER //
// ./src/components/preview/index.js